export default "__VITE_ASSET__DiGKzwoN__"